export const SESSION_STORAGE_KEYS = {
  IMPERSONATION_USER: 'impersonationUser',
  GLOBAL_SEARCH_STATE: 'globalSearchState',
};
